import { JsonProperty, JsonClassType } from "@outfoxx/jackson-js";

export class Geometry {
    @JsonProperty()
    type: string;
    @JsonProperty()
    @JsonClassType({ type: () => [Array, [Array, [Array, [Number]]]] })
    coordinates: number[];
}